import { Icon } from '@/kit/Icon';
import { DialogActions, DialogClose, DialogContent, type DialogComponentProps } from '@/kit/dialog';

export interface ApplyFirmTemplateConfirmData {
  clientName: string;
  /** e.g. "Limited company": the firm chart that is applied. */
  businessTypeName: string;
  /** The server's account of what applying adds (template status message). */
  message: string;
}

/**
 * BUG-034: Apply Firm Chart Template asks first. Resolves true (Yes), false (No) or undefined (X / dismissed).
 */
export function ApplyFirmTemplateConfirm({ data }: DialogComponentProps<ApplyFirmTemplateConfirmData, boolean>) {
  return (
    <div className="mat-dialog-wrapper">
      <DialogContent>
        <div className="main-contain">
          <div className="sidenav-header">
            <div className="d-flex align-items-center justify-space-between">
              <h2>
                <span>Apply Firm Chart Template</span>
              </h2>
              <DialogClose>
                <Icon name="close" className="close" />
              </DialogClose>
            </div>
          </div>
        </div>
        {data?.message && <p className="font-size-14">{data.message}</p>}
        <p className="font-size-14">
          Are you sure you want to apply the firm&apos;s <strong>{data?.businessTypeName}</strong> chart to{' '}
          <strong>{data?.clientName}</strong>?
        </p>
      </DialogContent>
      <DialogActions>
        <div className="d-flex gap-15">
          <DialogClose as="button" result={true} type="button" className="action-button primary-button">
            Yes
          </DialogClose>
          <DialogClose as="button" result={false} type="button" className="action-button secondary-button">
            No
          </DialogClose>
        </div>
      </DialogActions>
    </div>
  );
}
